module.exports = __webpack_public_path__ + "img/cropt-event-old.bf799b1a.jpg";